import styled, { keyframes } from "styled-components";
import LoopNoLabels from "../img/figures/loop/complete-loop-only.png";
import LoopLabelsInner from "../img/figures/loop/loop-label-inner.png";
import LoopLabelsOuter1 from "../img/figures/loop/loop-label-outer-1.png";
import LoopLabelsOuter2 from "../img/figures/loop/loop-label-outer-2.png";
import LoopLabelsOuter3 from "../img/figures/loop/loop-label-outer-3.png";
import { useEffect, useState } from "react";

const LayeredLoopContainer = styled.div`
    width: 100%;
    position: relative;
    aspect-ratio: 1 / 1;
`;


const LoopLayer = styled.img`
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    opacity: 0;

    transition: opacity 0.5s;
    transition-timing-function: linear;

    &.enter {
        opacity: 1;
    }

    &.exit {
        opacity: 0;
    }

    &.base-layer {
        opacity: 1;
    }


`;

const LayeredLoopImages = [
    LoopLabelsInner,
    LoopLabelsOuter1,
    LoopLabelsOuter2,
    LoopLabelsOuter3
]

const LayeredLoop = () => {


    const [imageIndex, setImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {

            setImageIndex(currentImageIndex => currentImageIndex + 1);

        }, 1000);
        return () => clearInterval(interval);
      }, []);

    return <LayeredLoopContainer>
        <LoopLayer src={LoopNoLabels} className="base-layer"/>

        {LayeredLoopImages.map((layer, i) => {
            if(i < imageIndex % (LayeredLoopImages.length + 1)) {
                return <LoopLayer key={`layered_loop_${i}`} src={layer} className="enter" />
            } else {
                return <LoopLayer key={`layered_loop_${i}`} src={layer} className="exit" />
            }

        })}

    </LayeredLoopContainer>
      
}

export default LayeredLoop;